import React, { FunctionComponent, useCallback, useEffect, useRef, useState } from 'react'
import './Details.scss'
import backarrow from '../../assets/icon_backarrow.svg'
import share from '../../assets/icon_share.svg'
import Iconarrow from '../../assets/icon_arrow_nor.svg'
import icon_copy from '../../assets/icon_copy.svg'
import icon_close from '../../assets/icon_close.svg'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import BundleRender from 'src/components/BundleRender/BundleRender'
import { Mask, Toast } from 'antd-mobile'
import axios from 'axios'
import copy from 'copy-to-clipboard'
import { urlSearch } from 'src/utils/tools'

// copy('Text');
interface DetailsProps {}

const Details: FunctionComponent<DetailsProps> = props => {
    const history = useHistory()

    const isSingle = sessionStorage.getItem('single')
    const locationParams = urlSearch(useLocation().search)
    const [showAnnotation, setShowAnnotation] = useState(false)
    const bundleDom = useRef(null)
    const contentWrapper = useRef(null)

    const [visible, setVisible] = useState(true)
    const [bundleInfo, setBundleInfo] = useState(
        {} as {
            name: string
            intro: string
            model: string
            cover: string
            bundleMax: number
            bundleMin: number
            light: { vsPath: string }
            background: { vsPath: string }
            camera: { vsPath: string }
        },
    )

    const [shareVisible, setShareVisible] = useState(false)
    const copyUrl = () => {
        copy(window.location.href)
        Toast.show({
            content: '复制成功',
        })
    }
    const [progressWidth, setProgressWidth] = useState(20)
    let progressId
    useEffect(() => {
        progressId = setInterval(() => {
            setProgressWidth(val => {
                if (val < 100) {
                    return val + 10
                } else {
                    clearInterval(progressId)
                    return val
                }
            })
        }, 500)
        bundleDom.current.addEventListener(
            'touchmove',
            function (e) {
                e.preventDefault()
            },
            { passive: false },
        ) //passive 参数不能省略，用来兼容ios和android
        return () => {
            clearInterval(progressId)
        }
    }, [])

    useEffect(() => {
        const width = bundleDom.current.clientWidth
        contentWrapper.current.style.width = `${width}px`
        axios({
            method: 'get',
            url: '/api/display/view',
            params: {
                id: locationParams.id,
            },
        }).then(res => {
            setBundleInfo(res.data.data)
        })
    }, [])
    return (
        <>
            <div className="cultural-details" ref={bundleDom}>
                <div
                    className="title"
                    style={
                        isSingle && {
                            flexDirection: 'row-reverse',
                        }
                    }
                >
                    {!isSingle && (
                        <img
                            src={backarrow}
                            onClick={() => {
                                if (isSingle) {
                                    return
                                }
                                history.push({ pathname: '/' })
                            }}
                        />
                    )}

                    <img
                        src={share}
                        onClick={() => {
                            setShareVisible(true)
                        }}
                    />
                </div>
                {bundleInfo.name && (
                    <BundleRender
                        backgroundUrl={bundleInfo.background.vsPath}
                        bundleUrl={bundleInfo.model}
                        lightUrl={bundleInfo.light.vsPath}
                        cameraUrl={bundleInfo.camera.vsPath}
                        bundleMax={bundleInfo.bundleMax || 2}
                        bundleMin={bundleInfo.bundleMin || 0.3}
                        bundleDom={bundleDom}
                        onCallback={() => {
                            clearInterval(progressId)
                            setVisible(false)
                        }}
                    ></BundleRender>
                )}
                <div
                    ref={contentWrapper}
                    className={`content-wrapper ${showAnnotation ? 'slip_in_animation' : ''}`}
                >
                    <div className={`content`}>
                        <p>{bundleInfo.intro || '暂无简介'}</p>
                    </div>
                </div>
                <div
                    className="cut"
                    onClick={() => {
                        setShowAnnotation(!showAnnotation)
                    }}
                >
                    <p className={`${showAnnotation && 'close'}`}>
                        {!showAnnotation && bundleInfo.name}
                    </p>
                    <img className={`${showAnnotation && 'img-close'}`} src={Iconarrow} alt="" />
                </div>
            </div>
            <Mask
                className="progress-modal"
                visible={visible}
                onMaskClick={() => setVisible(false)}
            >
                <div className="progress-modal_inner">
                    <div className="progress">
                        <div
                            style={{
                                width: `${progressWidth}px`,
                            }}
                        ></div>
                    </div>
                    <img src={bundleInfo.cover} alt="" />
                    <span className="loading">加载中…</span>
                </div>
            </Mask>
            <Mask
                className="share-modal"
                forceRender
                visible={shareVisible}
                onMaskClick={() => setShareVisible(false)}
            >
                <div className="share-modal_inner">
                    <img
                        className="close_icon"
                        src={icon_close}
                        onClick={() => {
                            setShareVisible(false)
                        }}
                    />
                    <p className="fenxiang">分享</p>
                    <div className="content">
                        <p className="title">{bundleInfo.name}</p>
                        <p className="introduction">{bundleInfo.intro}</p>
                        <img src={bundleInfo.cover} />
                    </div>
                    <div className="copy" onClick={copyUrl}>
                        <img className="copy_icon" src={icon_copy} alt="" />
                        <span>复制链接</span>
                    </div>
                </div>
            </Mask>
        </>
    )
}

export default Details
